import gql from 'graphql-tag';

export default gql`
  mutation checkStoreIsDuplicate($input: CheckStoreIsDuplicateInput!) {
    checkStoreIsDuplicate(input: $input) {
      isDuplicate
    }
  }
`;
